import axios from './axiosConfig'
export const postAxiosService = async (url, params = {}, header = {}) => {
  try {
    const response = await axios.post(url, params, header)
    return response.data
  } catch (error) {}
}
